import * as SnackStore from "../store/modules/snack";

function showSnack(text: string) {
  SnackStore.mutations.setText(text);
  SnackStore.mutations.showSnack();
}

function success(text: string) {
  SnackStore.mutations.setType("success");
  showSnack(text);
}

function error(text: string) {
  SnackStore.mutations.setType("error");
  showSnack(text);
}

function info(text: string) {
  SnackStore.mutations.setType("info");
  showSnack(text);
}

export default {
  success,
  error,
  info,
};
